module.exports = __webpack_public_path__ + "static/img/lianmeng3.a577277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/lianmeng3.jpg
// module id = 1418
// module chunks = 1